// extracted by mini-css-extract-plugin
export default {"dimmed":"bZNpZ","addRoom":"vFL3t","skeleton-progress":"Y57-Q"};